import http from "@/http/aisea/axios";
const resource = "/vessel_report/enterprise/vessel/report";

export default {
  fetch(reportId) {
    return http.get(`${resource}/${reportId}/confirm`);
  },
  read(payload) {
    return http.post(`${resource}/${payload.id}/confirm`, payload.req);
  }
};
